import { VideoJsPlayer } from 'video.js';

import { PlayerApi as PlayerApiValues } from '../types/player-api';
import { getAllowAutoplayState } from '../utils/settings';

export const PlayerApi = (videojs: VideoJsPlayer): PlayerApiValues => ({
  play: async (
    state = true,
    respectingAutoplaySettings = true
  ): Promise<void> => {
    const respectingAutoplay =
      respectingAutoplaySettings === null ? true : respectingAutoplaySettings;

    if (respectingAutoplay && !getAllowAutoplayState()) {
      // eslint-disable-next-line no-console
      console.warn(
        'XING Video API: Play was blocked because the user does not allow autoplay'
      );
      return undefined;
    }

    if (state) {
      return videojs.play();
    } else if (!videojs.isInPictureInPicture()) {
      videojs.pause();
      return undefined;
    }
  },

  pause: async (state = true): Promise<void> => {
    if (state) {
      if (!videojs.isInPictureInPicture()) {
        videojs.pause();
        return undefined;
      }
    } else {
      return videojs.play();
    }
  },

  setVolume: (volume) => {
    if (volume > 0) {
      videojs.muted(false);
    }

    return videojs.volume(volume / 100);
  },

  setMute: (state = !videojs.muted()) => {
    return videojs.muted(state);
  },
});
